import React from 'react';
import { AlertOctagon, AlertTriangle, CalendarClock, CheckCircle2, CircleHelp, Siren } from 'lucide-react';
import { RIESGO_LABEL, RIESGO_PILL, RIESGO_PUNTO } from 'lib/arboles';

// Riesgo de un árbol con color, ícono y texto (no depender solo del color).
// Bajo verde, medio ámbar, alto rojo, extremo rojo lleno con borde doble.
const ICONO = { bajo: CheckCircle2, medio: AlertTriangle, alto: AlertOctagon, extremo: Siren };

export default function RiesgoPill({ riesgo, className = '' }) {
  if (!riesgo) {
    return (
      <span className={`inline-flex shrink-0 items-center gap-1 rounded-full border border-border bg-muted px-2 py-0.5 text-xs font-semibold text-muted-foreground ${className}`}>
        <CircleHelp size={12} strokeWidth={2.5} aria-hidden="true" />Sin evaluar
      </span>
    );
  }
  const Icono = ICONO[riesgo] || CircleHelp;
  return (
    <span data-riesgo={riesgo} title={`Riesgo ${String(RIESGO_LABEL[riesgo] || riesgo).toLowerCase()}`}
      className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${RIESGO_PILL[riesgo] || 'border border-border bg-muted text-muted-foreground'} ${className}`}>
      <Icono size={12} strokeWidth={2.5} aria-hidden="true" />
      <span className="sr-only">Riesgo </span>{RIESGO_LABEL[riesgo] || riesgo}
    </span>
  );
}

// Riesgo discreto, como en las fichas del tablero: punto de color con el
// nivel en texto (nunca solo color). Alto y extremo suben a texto de error,
// sin fondo ni borde: se nota, pero no grita.
export function RiesgoDiscreto({ riesgo, grande = false, className = '', textoVacio = 'Sin evaluar' }) {
  const tam = grande ? 'gap-2 text-base font-semibold' : 'gap-1.5 text-xs font-medium';
  const punto = grande ? 'h-2.5 w-2.5' : 'h-2 w-2';
  if (!riesgo) {
    return (
      <span className={`inline-flex items-center text-muted-foreground ${tam} ${className}`}>
        <span className={`${punto} shrink-0 rounded-full border border-muted-foreground/60`} aria-hidden="true" />{textoVacio}
      </span>
    );
  }
  const fuerte = riesgo === 'alto' || riesgo === 'extremo';
  const color = fuerte ? 'text-error' : grande ? 'text-foreground' : 'text-muted-foreground';
  return (
    <span data-riesgo={riesgo} className={`inline-flex items-center ${tam} ${color} ${className}`}>
      <span className={`${punto} shrink-0 rounded-full ${RIESGO_PUNTO[riesgo] || 'bg-muted-foreground'}`} aria-hidden="true" />
      <span className="sr-only">Riesgo </span>{RIESGO_LABEL[riesgo] || riesgo}
    </span>
  );
}

// "Vencida" (la próxima evaluación ya pasó). Discreta, como en las fichas
// del tablero: texto atenuado con un reloj, sin fondo rojo.
export function MarcaVencida({ texto = 'Evaluación vencida' }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground">
      <CalendarClock size={12} aria-hidden="true" />{texto}
    </span>
  );
}
